import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageEnlargerConfig } from '@/data/landingConfig/landingImageEnlargerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageEnlarger } from './schemaObject';

const ImageEnlarger = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageEnlarger} />
			<LandingTemplate
				data={landingImageEnlargerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageUpscaleV3()}
			/>
		</>
	);
};

export default ImageEnlarger;
